import * as _ from 'underscore';
import {noop} from 'rxjs/util/noop';
import {Component, ElementRef, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';

declare var Slider: any;
declare var jQuery: any;
// slider properties https://github.com/seiyria/bootstrap-slider
// see slider events, etc here http://www.eyecon.ro/bootstrap-slider/
// ngcontrol http://almerosteyn.com/2016/04/linkup-custom-control-to-ngcontrol-ngmodel
/**
 * This class represents the slider component.
 * This is custom implementation that does not support all bootstrap-slider features
 */
@Component({
    moduleId: module.id,
    /* tslint:disable:component-selector-name */
    selector: 'slider',
    template: '<div><input [(ngModel)]="value" class="slider-input" type="text" style="width:100%" /></div>',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SliderComponent),
            multi: true
        }
    ]
})
export class SliderComponent implements ControlValueAccessor, OnInit, OnDestroy {

    @Input() max: number;
    @Input() min: number;
    @Input() step: number;
    @Input() enabled: boolean = true;
    @Input() sliderid: string;
    @Input() updateevent: string;
    @Input() orientation: string;
    @Input() selection: string;
    @Input() handle: string;
    @Input() ticksTooltip: boolean;
    @Input() reversed: boolean;

    @Input() formControl: FormControl;
    @Input() private _value: number;

    private MAX_TICKS = 10;

// TODO:            replace: true,

    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    writeValue(obj: any): void {
        // console.log('SliderComponent: writeValue:', obj);
        this.value = obj;
    }

    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        // console.log('SliderComponent: setDisabledState:', isDisabled);
        this.enabled = !isDisabled;
        this.enabled ? this.getSlider().enable() : this.getSlider().disable();
    }

    //Set touched on blur
    onBlur() {
        // console.log('SliderComponent: onBlur:');
        this.onTouchedCallback();
    }

    get value(): number {
        // console.log('SliderComponent: get value:', this.value);
        return this._value;
    }

    set value(value: number) {
        // console.log('SliderComponent: set value:', value);
        this._value = value;
        this.onChangeCallback(this._value);
    }

    constructor(private myElement: ElementRef) {
        // console.log('SliderComponent: constructor:', myElement);
    }

    ngOnInit() {
        this.initSlider();
    }


    ngOnDestroy(): void {
        const element: any = this.myElement;
        const slider: any = element['_slider'];
        if (slider) {
            slider.destroy();
            element['_slider'] = null;
        }
    }

    getSlider(): any {
        const element: any = this.myElement;
        return element['_slider'];
    }

    initSlider() {
        // console.log('SliderComponent: initSlider:', 'formControl:', this.formControl);

        const _self = this;
        const options: any = {};

        function setOption(key: string, value: any, defaultValue?: any) {
            options[key] = value || defaultValue;
        }

        function setFloatOption(key: string, value: any, defaultValue: any) {
            options[key] = value || value === 0 ? parseFloat(value) : defaultValue;
        }

        function setBooleanOption(key: string, value: any, defaultValue: any) {
            options[key] = value ? value + '' === 'true' : defaultValue;
        }

        function getArrayOrValue(value: any) {
            return (typeof value === 'string' && value.indexOf('[') === 0) ? JSON.parse(value) : value;
        }

        setOption('id', this.sliderid);
        setOption('orientation', this.orientation, 'horizontal');
        setOption('selection', this.selection, 'before');
        setOption('handle', this.handle, 'round');

        setOption('ticks_tooltip', this.ticksTooltip, false);
        setBooleanOption('reversed', this.reversed, false);

        setFloatOption('min', this.min, 0);
        setFloatOption('max', this.max, 10);
        setFloatOption('step', this.step, 1);

        // const strNbr = options['step'] + '';
        // const dotPos = strNbr.search(/[^.,]*$/);
        // const decimals = strNbr.substring(dotPos);

        if (this.max) {
            // const k = 10;
            // const ticks = _.toArray([1]).concat(_.range(10, this.max - 1, 10)).concat(_.toArray([this.max]));
            // console.log('ticks:', ticks);
            const ticks = this.produceTicks(this.max);
            // const ticks = _.toArray([1]).concat(_.range(40, this.max - 1, 40)).concat(_.toArray([this.max]));
            // const ticks = _.toArray([1]).concat(_.range(5, this.max - 1, 5)).concat(_.toArray([this.max]));
            const ticksLabels = ticks;
            setOption('ticks', ticks);
            setOption('ticks_labels', ticksLabels);
            setOption('ticks_positions', this.produceSliderTickPercents(this.min, this.max, ticks));
            // setOption('ticks_positions', _.toArray([1*k]).concat(_.range(5*k, (this.max - 1)*k, 5*k)).concat(_.toArray([this.max*k])));
        }

        setBooleanOption('enabled', !this.formControl.disabled, true);

        if (options['range']) {
            // TODO: range
        } else {
            setFloatOption('value', this.formControl.value, this.min);
        }

        // check if slider jQuery plugin exists
        if (jQuery.fn.slider) {
            // adding methods to jQuery slider plugin prototype
            jQuery.fn.slider.constructor.prototype.disable = function () {
                // console.log('SliderComponent: initSlider: disable picker', this);
                this.picker.off();
            };
            jQuery.fn.slider.constructor.prototype.enable = function () {
                // console.log('SliderComponent: initSlider: enable picker', this);
                this.picker.on();
            };
        }

        const slider = new Slider(this.myElement.nativeElement, options);
        const element: any = this.myElement;
        element['_slider'] = slider;

        // console.log('SliderComponent: initSlider: new Slider',
        //     'slider:', slider,
        //     'myElement:', this.myElement,
        //     'options:', options,
        //     'jQuery.fn.slider:', jQuery.fn.slider);

        // enable state
        this.enabled ? slider.enable() : slider.disable();

        // everything that needs slider element
        var updateEvent = getArrayOrValue(this.updateevent);
        if (typeof updateEvent === 'string') {
            // if only single event name in string
            updateEvent = [updateEvent];
        } else {
            // default to slide event
            updateEvent = ['slide'];
        }
        _.each(updateEvent, function (sliderEvent) {
            slider.on(sliderEvent, function (value: any) {
                // console.log('SliderComponent: initSlider: on sliderEvent', sliderEvent, value);
                // _self.value = value;
                _self.formControl.setValue(value);
            });
        });

        // if on change is needed
        // slider.on('change', function (ev : any) {
        //     console.log('SliderComponent: initSlider: on change', ev);
        //     _self.value = ev.newValue;
        // });


        return slider;
    }


    // fix to "tick labels are not correctly positioned under ticks when latter created at different step"
    // https://github.com/seiyria/bootstrap-slider/issues/660
    private produceSliderTickPercents(min: number, max: number, values: number[]): any[] {
        let returns: number[] = [];
        _.each(values, function (value: number) {
            const v = value;
            const val = 100 * (v - min) / (max - min);
            returns.push(val);
        });

        return returns;
    }

    // Below is modified code from http://stackoverflow.com/questions/4947682/intelligently-calculating-chart-tick-positions
    // The generated ticks always start from 1 and end with axis_end
    // The step is calculated based on log function
    // The number of ticks is limited to MAX_TICKS

    private produceTicks(axis_end: number): number[] {
        const ticks = this.nice_bounds(1, axis_end, this.MAX_TICKS);
        // console.log('ticks', ticks);
        const ret: number[] = [];
        // let index = 0;
        for (let i = ticks.min; i <= ticks.max; i += ticks.steps) {
            const val = i === 0 ? 1 : (i > axis_end ? axis_end : i);
            // console.log(++index, i, val);
            ret.push(val);
        }
        // console.log('SliderComponent: produceTicks:', axis_end, 'ticks:', ticks, 'ret:', ret);
        return ret;
    }

    private nice_number(value: number, round_?: boolean): number {
        //default value for round_ is false
        round_ = round_ || false;
        // :latex: \log_y z = \frac{\log_x z}{\log_x y}
        const exponent = Math.floor(Math.log(value) / Math.log(10));
        const fraction = value / Math.pow(10, exponent);

        let nice_fraction: number;

        if (round_) {
            if (fraction < 1.5) {
                nice_fraction = 1.0;
            } else if (fraction < 3.0) {
                nice_fraction = 2.0;
            } else if (fraction < 7.0) {
                nice_fraction = 5.0;
            } else {
                nice_fraction = 10.0;
            }
        } else if (fraction <= 1) {
            nice_fraction = 1.0;
        } else if (fraction <= 2) {
            nice_fraction = 2.0;
        } else if (fraction <= 5) {
            nice_fraction = 5.0;
        } else {
            nice_fraction = 10.0;
        }

        return nice_fraction * Math.pow(10, exponent);
    }

    private nice_bounds(axis_start: number, axis_end: number, num_ticks: number): any {
        //default value is 10
        num_ticks = num_ticks || 10;
        let axis_width = axis_end - axis_start;

        if (axis_width === 0) {
            axis_start -= .5;
            axis_end += .5;
            axis_width = axis_end - axis_start;
        }

        const nice_range = this.nice_number(axis_width);
        let nice_tick = this.nice_number(nice_range / (num_ticks - 1), true);

        if (!isNaN(nice_tick)) {
            axis_start = Math.floor(axis_start / nice_tick) * nice_tick;
            axis_end = Math.ceil(axis_end / nice_tick) * nice_tick;

            // fixing nice_tick always to be number without decimal
            if (nice_tick < 1.0) {
                nice_tick = 1;
            }

        } else {
            nice_tick = 1;
            axis_start = 1;
            axis_end = 1;
        }
        return {
            'min': axis_start,
            'max': axis_end,
            'steps': nice_tick
        };
    }
}
